<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <el-row>
      <el-col :span="8">
        <el-form-item label="申报单位">
          <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="所属部门">
          <el-input size="small" :disabled="true" v-model="userData.childDept"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <div class="clear kq-item" v-for="item in form.items">
      <el-form-item label="未签到时间">
        <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="item.time" type="date" placeholder="选择未签到时间"
          style="margin-right:20px;">
        </el-date-picker>
        <el-checkbox v-model="item.swqd">上午签到</el-checkbox>
        <el-checkbox v-model="item.swqt">上午签退</el-checkbox>
        <el-checkbox v-model="item.xwqd">下午签到</el-checkbox>
        <el-checkbox v-model="item.xwqt">下午签退</el-checkbox>
      </el-form-item>
      <el-form-item label="未签到原因">
        <el-input type="textarea" placeholder="未签到原因" :autosize="{ minRows: 3, maxRows: 4}" size="small"
          v-model="item.reason"></el-input>
      </el-form-item>
    </div>
    <el-button type="primary" @click="addItem()" size="mini" style="float:right;margin:5px 0 0 0;">添加一组</el-button>

    <!-- <div class="clear">
      <el-col :span="8">
        <el-form-item label="请假类别">
          <el-select size="small" v-model="form.type" placeholder="请选择请假类别">
            <el-option v-for="item in typeArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="已请年休假" v-if="form.type=='年休假'">
          <el-input size="small" style="width:150px;" :disabled="true" v-model="form.leaveDays"></el-input>
          天
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-form-item label="请假时间">
        <el-date-picker size="small" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.startTime" type="datetime"
          placeholder="选择开始时间">
        </el-date-picker>
        <span>至</span>
        <el-date-picker size="small" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.endTime" type="datetime"
          placeholder="选择结束时间">
        </el-date-picker>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;共<el-input type="number" size="small"
          style="width:50px;margin:0 5px;" v-model="form.totalTime"></el-input>天
      </el-form-item>
    </div>
 -->
    <!-- <el-form-item label="备注">
      <el-input type="textarea" placeholder="备注" :autosize="{ minRows: 5, maxRows: 8}" size="small"
        v-model="form.remark"></el-input>
    </el-form-item> -->

  </section>
</template>

<script>
  export default {
    props: ['formByFather', 'userData', 'teamArr', 'projectArr'],
    data() {
      return {
        form: {},
        // typeArr: ['公出', '调休', '病假', '事假', '年休假', '其他', ],
        // leaveDays: '',
      }
    },
    created() {
      // this.getLeaveDays()
    },
    mounted() {
      this.form = this.formByFather

      this.form.depId = this.userData.secDepIds.split(",")[0]
      // this.form.leaderId = this.userData.id
      // this.form.leaveDays = this.leaveDays

      // if (this.userData.joinTime && !this.form.applyTime) {
      //   this.form.applyTime = this.formatData(this.userData.joinTime)
      // }
    },
    methods: {
      // 添加一组
      addItem() {
        this.form.items.push({
          "reason": "",
          "swqd": 0,
          "swqt": 0,
          "time": "",
          "xwqd": 0,
          "xwqt": 0
        })
      },
      // 获取已请年假天数
      // getLeaveDays() {
      //   ajax.get('/human/leave/days', '', res => {
      //     this.form.leaveDays = this.leaveDays = res.vo.data
      //   })
      // },

      formatData(data) {
        let _data = ''
        if (data.split("-").length != 3) {
          let _d = data.split("-")
          _data += _d[0] + '-'
          _data += _d[1] ? _d[1] : '01'
          _data += _d[2] ? _d[2] : '01'
        } else {
          _data = data
        }
        return _data
      },

      getFromData() {
        // if (this.form.time) {
        //   this.form.startTime = this.form.time[0]
        //   this.form.endTime = this.form.time[1]
        // }
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
        // this.form.leaveDays = this.leaveDays
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/page/form/personnel/kqApproval.vue